import { Box } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';

import { warningTypeColorMap } from 'core/constants';
import { WarningType } from 'core/enums';
import { theme } from 'theme';
import { Color } from 'theme/enums';

import TextEllipsis from './TextEllipsis';
import { WarningValidationIcon } from './WarningValidationIcon';

const contentStyle = (hasWarning: boolean, color: Color) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '10px',
  color: hasWarning ? `rgba(${theme.palette?.[color].mainChannel} / 1)` : 'inherit',
});

interface IProps {
  content: string | JSX.Element;
  showWarning?: boolean;
  color?: Color;
  type?: WarningType;
  textEllipsis?: boolean;
  sx?: SxProps;
}

export const WarningCell = ({
  content,
  showWarning,
  color,
  type = WarningType.ERROR,
  textEllipsis = false,
  sx,
}: IProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        width: '100%',
        gap: '4px',
        fontSize: 'inherit',
        lineHeight: '21px',
        ...sx,
      }}
    >
      {showWarning && <WarningValidationIcon type={type} />}

      {textEllipsis ? (
        <TextEllipsis
          content={content}
          color={showWarning ? color || warningTypeColorMap[type] : null}
        />
      ) : (
        <Box sx={contentStyle(showWarning, color || warningTypeColorMap[type])}>{content}</Box>
      )}
    </Box>
  );
};
